import { Avatar, Box, Button, Container, createTheme, CssBaseline, Grid, IconButton, Paper, ThemeProvider, Tooltip, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { getByRegistroClaveProyecto } from "../../../../database/dbRegistroGeneral";

import MUIDataTable from "mui-datatables";
import moment from "moment";
import Swal from "sweetalert2";
import { DownloadOutlined } from "@mui/icons-material";


export const Sina2025Panel = () => {

    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

    const [reportData, setReportData] = useState([]);

    const columns = [
        { name: "registroReferencia", label: 'Referencia',
            options: {
                filter: true,
                sort: false,
                setCellHeaderProps: () => ({
                    style: {
                        whiteSpace: "nowrap",
                        position: "sticky",
                        left: 0,
                        background: "white",
                        fontWeight: 600,
                        textAlign: 'center',
                        zIndex: 101,
                    },
                }),
                setCellProps: () => ({
                    style: {
                        whiteSpace: "nowrap",
                        position: "sticky",
                        left: "0",
                        background: 'whitesmoke',
                        textAlign: 'center',
                        fontWeight: 600,
                        zIndex: 100,
                    },
                }),
                customBodyRender: value => <Tooltip title='Abrir en modo edición'>
                    <a 
                        href={ `${ process.env.REACT_APP_HOMEPAGE }/sina2025/trabajos/revision?id=${ value }` }
                        target='_blank'
                    >
                        { value }
                    </a>
                    {/* <Button 
                        color='info' 
                        fullWidth 
                        onClick={ () => console.log(value) } 
                        variant='contained'
                    >
                        { value }
                    </Button> */}
                </Tooltip>,
            },
        },
        { name: "partApellidoPaterno", label: 'Apellido paterno',
            options: {
                sort: false,
                setCellHeaderProps: () => ({ style: { fontWeight: 600 }, }),
            },
        },
        { name: "partApellidoMaterno", label: 'Apellido materno',
            options: {
                sort: false,
                setCellHeaderProps: () => ({ style: { fontWeight: 600 }, }),
            },
        },
        { name: "partNombres", label: 'Nombres',
            options: {
                sort: false,
                setCellHeaderProps: () => ({ style: { fontWeight: 600 }, }),
            },
        },

        { name: "partCorreo", label: "Correo", options: { display: false } },
        { name: "partPais", label: "Pais", options: { display: false } },
        { name: "partEstado", label: "Estado", options: { display: false } },

        { name: "tipoRegistro", label: 'Tipo de registro',
            options: {
                sort: false,
                setCellHeaderProps: () => ({ style: { textAlign: 'center', fontWeight: 600 }, }),
                setCellProps: () => ({ style: { textAlign: 'center', }, }),
            },
        },

        { name: "tipoRegistroDocURL", label: "Credencial", options: { display: false } },

        { name: "infoAdicional", label: 'Modalidad',
            options: {
                download: false,
                sort: false,
                setCellHeaderProps: () => ({ style: { textAlign: 'center', fontWeight: 600 }, }),
                setCellProps: () => ({ style: { textAlign: 'center', }, }),
                customBodyRender: value => (<div>{ value.modalidad }</div>),
            },
        },
        { name: "infoAdicional", label: 'Comprobante',
            options: {
                download: false,
                sort: false,
                setCellHeaderProps: () => ({ style: { textAlign: 'center', fontWeight: 600 }, }),
                setCellProps: () => ({ style: { textAlign: 'center', }, }),
                customBodyRender: value => <div>
                    { 
                        value.datosFactura 
                        ? <a href={ value.datosFactura.comprobanteURL } target='_blank'>
                        { moment(value.datosFactura.updatedAt).format('YYYY-MM-DD') }
                        </a>
                        : 'Pendiente' 
                    }
                </div>,
            },
        },
        { name: "infoAdicional", label: 'Datos factura',
            options: {
                download: false,
                sort: false,
                setCellHeaderProps: () => ({ style: { textAlign: 'center', fontWeight: 600 }, }),
                setCellProps: () => ({ style: { textAlign: 'center', }, }),
                customBodyRender: value => <div>
                    { 
                        value.datosFactura 
                        ? <Button 
                            // color='info'
                            variant='text'
                            size='small'
                            onClick={ () => showInvoiceDetails(value.datosFactura) }
                            // onClick={ () => console.log(value.datosFactura) }
                        >
                        Ver
                        </Button>
                        : 'Pendiente' 
                    }
                </div>,
            },
        },

        { name: "registroFecha", label: "Fecha de registro", options: { display: false } },
        { name: "partGenero", label: "Genero", options: { display: false } },
        { name: "partNacionalidad", label: "Nacionalidad", options: { display: false } },
        { name: "partTelefono", label: "Telefono", options: { display: false } },

        { name: "profInstitucion", label: "Institucion", options: { display: false } },
        { name: "profDireccion", label: "Direccion", options: { display: false } },
        { name: "profGrado", label: "Grado", options: { display: false } },
        { name: "profPais", label: "Pais", options: { display: false } },
        { name: "profEstado", label: "Estado", options: { display: false } },
        { name: "modalidad", label: "Modalidad", options: { display: false } },
        { name: "concursoPoster", label: "Concurso Poster", options: { display: false } },
        { name: "concursoFoto", label: "Concurso Foto", options: { display: false } },
        
        { name: "foto1", label: "Foto 1", options: { display: false } },
        { name: "foto2", label: "Foto 2", options: { display: false } },
        { name: "listaAutores", label: "Listado de autores y descripciones", options: { display: false } },
        { name: "cartaFirmada", label: "Carta firmada", options: { display: false } },

        { name: "comprobanteURL", label: "Comprobante de pago", options: { display: false } },
        { name: "requiereFactura", label: "Requiere Factura", options: { display: false } },
        { name: "aNombreDe", label: "A Nombre De", options: { display: false } },
        { name: "correo", label: "Correo electronico", options: { display: false } },
        { name: "concepto", label: "Concepto", options: { display: false } },
        { name: "constanciaURL", label: "Constancia de Situación Fiscal", options: { display: false } },
        { name: "facturaTipo", label: "Nacional o Extrajero", options: { display: false } },
        { name: "personaTipo", label: "Física o Moral", options: { display: false } },
        { name: "RFC", label: "RFC", options: { display: false } },
        { name: "CP", label: "CP", options: { display: false } },
        { name: "UsoCFDI", label: "Uso CFDI", options: { display: false } },
        { name: "RegimenFiscal", label: "Regimen Fiscal", options: { display: false } },
        { name: "formato32DURL", label: "Formato 32D", options: { display: false } },
        { name: "updatedAt", label: "Fecha de comprobación", options: { display: false } },
    ];

    const options = {
        print: false,
        filter: false,
        download: true,
        viewColumns: false,
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "460px",
        // selectableRows: 'single',
        selectableRows: 'none',
        rowsPerPage: 30,
        rowsPerPageOptions: [30, 60, 100],
    
        downloadOptions: {
            filename: `sina-excel-${ moment( Date.now() ).format('YYYY-MM-DDTHHmmss') }.csv`,
        },
        // Al presionar el boton de descarga
        onDownload: (buildHead, buildBody, columns, data) => onDownloadCustom(buildHead, buildBody, columns, data),
        
        textLabels: {
            toolbar: {
                search: "Buscar",
                downloadCsv: "Descargar CSV",
                viewColumns: "Mostrar Columnas",
            },
            viewColumns: {
                title: "Mostrar Columnas",
            },
            pagination: {
              next: "Siguiente",
              previous: "Anterior",
              rowsPerPage: "Renglones por página:",
              displayRows: "de",
            },
        },
    };
    
    const onDownloadCustom = (buildHead, buildBody, columns, data) => {
        console.log({columns});
        /**
         * //* Para generar 'dataToUse'
         * Hay que recorrer 'reportData' y para cada elemento generar un objeto { index: , data: }
         * 'index' es la posicion de ese atributo en 'columnsToUse'
         * 'data' es un array de los valores obtenidos de recorrer 'columnsToUse', si no tiene ese atributo devuelve ''
         * Ciclo 1: reportData - Ciclo 2: columnsToUse
         * "Para cada 'item' en 'reportData', recorrer 'columnsToUse' y para cada 'column' obtener su valor en 'item'
         */
        
        let dataToUse = reportData.map( (item, iItem) => {
            // console.log({item});
            let dataArray = columns.map(({ name }) => {
                // console.log({name})
                //* En la raiz
                let value = item[name];
                // Si es vacio porque para el usuario era opcional y no lo capturo o,
                // Si existe y tiene algo capturado
                if (value === '' || (value && value.length)) { return value; }
                //* En 'infoAdicional'
                value = item.infoAdicional[name];
                // console.log({value})
                if (value === '' || (value && value.length)) { return value; }

                // * En 'infoAdicional.concursoFotoArchivos'
                // El nombre de la columna: 'name', debe ser alguno de los campos que vienen en el objeto 'concursoFotoArchivos'
                if (item.infoAdicional.concursoFotoArchivos && ['foto1', 'foto2', 'listaAutores', 'cartaFirmada'].includes(name) ) {
                    return item.infoAdicional.concursoFotoArchivos[name]
                }

                // * En 'infoAdicional.datosFactura'
                // Solo el ultimo puede no especificar cada uno de los campos
                if (item.infoAdicional.datosFactura) {
                    return item.infoAdicional.datosFactura[name]
                }
            })

            const itemObject = { index: iItem, data: dataArray };
            return itemObject;
        })

        // console.log({dataToUse});
        Swal.fire({
            title: 'Archivo descargado',
            icon: 'success',
            text: 'El archivo se ha descargado correctamente.',
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
        });

        //* Se agrega "\uFEFF" para que soporte caracteres especiales
        return "\uFEFF" + buildHead(columns) + buildBody(dataToUse); 
    }

    const showInvoiceDetails = (datosFactura) => {
        console.log(datosFactura);
        Swal.fire({
            title: "Solicitud de factura",
            html: `
                <div style="text-align: left;">
                    <p><a href=${ datosFactura.comprobanteURL } target="_blank">Comprobante de pago</a></p>
                    <p><strong>Requiere factura:</strong> ${ datosFactura.requiereFactura }</p>
                    <p><strong>Nombre:</strong> ${ datosFactura.aNombreDe }</p>
                    <p><strong>Correo:</strong> ${ datosFactura.correo }</p>
                    <p><strong>Tipo de factura:</strong> ${ datosFactura.facturaTipo }</p>
                    <p><strong>RFC:</strong> ${ datosFactura.RFC }</p>
                    <p><strong>CP:</strong> ${ datosFactura.CP }</p>
                    <p><strong>Uso CFDI:</strong> ${ datosFactura.UsoCFDI }</p>
                    <p><strong>Regimen Fiscal:</strong> ${ datosFactura.RegimenFiscal }</p>
                    <p><a href=${ datosFactura.constanciaURL } target="_blank">Constancia de Situación Fiscal</a></p>
                    <p><strong>Concepto:</strong> ${ datosFactura.concepto }</p>
                    <p><a href=${ datosFactura.formato32DURL } target="_blank">Formato 32D</a></p>
                </div>
            `,
            showCloseButton: true,
            showConfirmButton: false,
        });
    }

    const loadRecords = async() => {
        const { data: recordsRegistroGeneral } = await getByRegistroClaveProyecto('74622');
        // console.log({recordsRegistroGeneral});
        
        const recordsTmp = recordsRegistroGeneral.map(r => {
            const item = { ...r, infoAdicional: JSON.parse(r.infoAdicional) }
            return item;
        })
        // console.log({recordsTmp});

        setReportData(recordsTmp);
    }


    useEffect(async() => {

        const { value: password } = await Swal.fire({
            title: 'Ingrese el password asignado.',
            input: 'password',
            inputPlaceholder: 'Password',
            inputAttributes: {
                maxlength: 8,
                autocapitalize: 'off',
                autocorrect: 'off'
            }
        })
        // Si el password es correcto
        if (password.toLowerCase() === 'sina2025') {
            await loadRecords();
            setIsUserLoggedIn(true);
        } else {
            Swal.fire({
                title: "El password es incorrecto.",
                text: 'Confirme el dato y vuelva a intentarlo.',
                icon: 'error',
                confirmButtonText: 'Reintentar',
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('./panel');
                }
            }); 
        }

        // //* Para pruebas...
        // await loadRecords();
        // setIsUserLoggedIn(true);
    }, [ ])
    

    return isUserLoggedIn && (
        <ThemeProvider theme={createTheme()}>
            <Container component="main">
                <CssBaseline />
                <Box sx={{ mt: 2, mb: 8, display: 'flex', flexDirection: "column", alignItems: "center" }} >
                    <Avatar src='https://aena.mx/images/nicepage-images/80f8a68a08b4341bcc455d466709dc31.png' sx={{ width: 100, height: 'auto', pb: 2 }} />
                    <Typography fontSize={ 26 } fontWeight={ 900 }>Simposio Internacional en Nutrición Acuícola</Typography>
                    <Typography variant='h6'>Panel de gestión de participaciones</Typography>

                    <Grid container py={ 2 }>
                        <Grid item xs={ 12 }>
                            <MUIDataTable
                                title={ ' ' }
                                columns={ columns }
                                data={ reportData }
                                options={ options }
                            />
                        </Grid>
                    </Grid>

                </Box>
            </Container>
        </ThemeProvider>
    )
}


/*

{
    "id": 502,
    "partApellidoPaterno": "Collins",
    "partApellidoMaterno": "Gomez",
    "partNombres": "Jorge",
    "partCorreo": "jorgecollins@hotmail.com",
    "partPais": "",
    "partEstado": "",
    "tipoRegistro": "Posdoctorado",
    "tipoRegistroDocURL": "",
    "registroClaveProyecto": "74622",
    "registroFecha": "2025-02-26T13:45:51",
    "registroReferencia": "7462274060265623",
    "infoAdicional": {
        "partGenero": "Masculino",
        "partNacionalidad": "Mexicana",
        "partTelefono": "",
        "profInstitucion": "ITLP",
        "profDireccion": "Chichenitza 551 entre Gómez Farías y Quetzalcoatl",
        "profGrado": "",
        "profPais": "Argentina",
        "profEstado": "",
        "modalidad": "Participante",
        "trabajos": [
            {
                "title": "Nombre del trabajo que se presentara en el evento",
                "authors": [
                    {
                        "id": "55556635-1348-4b04-a4c2-6541c3bd96b4",
                        "names": "Armando",
                        "lastnames": "Gomez",
                        "institution": "FUNIBER",
                        "email": "contacto@corosoftware.com"
                    }
                ],
                "id": "b6c9d61e-6ca2-4e27-ae10-d221a6707bd2",
                "ownerId": "7462274060265623",
                "status": "devuelto",
                "statusComments": "Cambiar el contexto.",
                "keywords": [
                    "asd",
                    "33333"
                ],
                "url": "https://eventos.cibnor.mx/registro/apiServiciosSIARF/UploadFiles/7462274060265623_b6c9d61e-6ca2-4e27-ae10-d221a6707bd2.docx",
                "method": "",
                "mediaFilesURL": ""
            }
        ],
        "concursoPoster": "0",
        "concursoFoto": "1",
        "isStudent": "0",
        "isSponsor": "0",
        "datosFactura": {
            "comprobanteURL": "https://eventos.cibnor.mx/registro/apiServiciosSIARF/UploadFiles/7462274060265623_comprobante.pdf",
            "requiereFactura": "No",
            "aNombreDe": "",
            "concepto": "",
            "constanciaURL": "",
            "correo": "",
            "facturaTipo": "",
            "personaTipo": "",
            "RFC": "",
            "CP": "",
            "UsoCFDI": "",
            "RegimenFiscal": "",
            "formato32DURL": "",
            "updatedAt": "2025-03-01T21:27:32"
        },
        "concursoFotoArchivos": {
            "foto1": "https://eventos.cibnor.mx/registro/apiServiciosSIARF/UploadFiles/7462274060265623_foto1.jpg",
            "cartaFirmada": "https://eventos.cibnor.mx/registro/apiServiciosSIARF/UploadFiles/7462274060265623_cartaFirmada.pdf"
        }
    }
}

*/